<!--
    系统中心-路由结构
    作用：教学平台、校区管理后台、课件器管理后台的路由结构
    功能：展示/新增/编辑路由菜单
    组件:el-tree
-->
<template>
  <div class="router">
    <el-button
      type="primary"
      @click="create">添加菜单</el-button>
    <div class="tree">
      <el-tree
        :default-expand-all="true"
        :props="treeProps"
        :data="data"
        node-key="id"
        children="children">
        <div
          slot-scope="{ node, data }"
          class="subject-edition__node">
          <span>{{ node.label }}</span>
          <span class="subject-edition__node-control">
            <el-button
              type="text"
              size="mini"
              @click="() => editNode(data.id, node, data)"
            >编辑</el-button>
            <el-button
              :style="{ visibility: node.isLeaf ? 'visible' : 'hidden'}"
              type="text"
              size="mini"
              @click="() => deleteNode(node, data)"
            >删除</el-button>
            <el-button
              type="text"
              size="mini"
              @click="() => appendNode(node, data)"
            >+添加子菜单</el-button>
          </span>
        </div>
      </el-tree>
    </div>
    <el-dialog
      :title="dialogTitle === 'add' ? '新增菜单' : '编辑菜单'"
      :visible.sync="formDialogVisible"
      width="500px">
      <el-form
        ref="form"
        :rules="rules"
        :model="formData"
        label-width="125px">
        <el-form-item
          label="菜单名称："
          prop="name">
          <el-input
            v-model="formData.name"
            placeholder="请输入菜单名称"/>
        </el-form-item>
        <el-form-item
          label="路由名称："
          prop="route_name">
          <el-input
            v-model="formData.route_name"
            placeholder="请输入路由名称"/>
        </el-form-item>
        <el-form-item label="图标：">
          <el-input
            v-model="formData.icon"
            placeholder="请输入图标类名"/>
        </el-form-item>
        <el-form-item label="url：">
          <el-input
            v-model="formData.url"
            placeholder="请输入url"/>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="formDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'Router',
  inject: ['reload'],
  data() {
    return {
      formDialogVisible: false,
      dialogTitle: '',
      isSubmit: true,
      permissionId: 0,
      data: {},
      treeProps: {
        label: 'name',
        children: 'children',
      },
      formData: {
        parent_id: 0,
        route_name: '',
        name: '',
        url: '',
        icon: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' },
        ],
        route_name: [
          { required: true, message: '请输入路由名称', trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    this.$http.get('/api/service/operate/permission')
      .then((res) => {
        this.data = res.view;
      })
      .catch((err) => {
        this.$message.error(err.message);
      });
  },
  methods: {
    create() {
      this.dialogTitle = 'add';
      this.formDialogVisible = true;
      this.formData = {
        parent_id: 0,
        route_name: '',
        name: '',
        url: '',
        icon: '',
      };
    },
    editNode(id, node, data) {
      console.log('edit', id, node, data);
      this.dialogTitle = 'edit';
      this.formDialogVisible = true;
      this.permissionId = id;
      this.formData = {
        parent_id: data.parent_id,
        route_name: data.route_name,
        name: data.name,
        url: data.url,
        icon: data.icon,
      };
    },
    deleteNode(node, data) {
      console.log('delete', node, data);
      this.$confirm('确定删除该菜单么？', '删除确认', {
        showCancelButton: true,
        type: 'warning',
        confirmButtonText: '删除',
        confirmButtonClass: 'el-button--danger',
      })
        .then(() => {
          this.$http.delete(`/api/service/operate/permission/${data.id}`)
            .then(() => {
              this.$message.success('删除成功！');
              this.reload();
            })
            .catch((err) => {
              this.isSubmit = true;
              this.$message.error(err.message);
            });
        });
    },
    appendNode(node, data) {
      console.log('appent', node, data);
      this.dialogTitle = 'add';
      this.formDialogVisible = true;
      this.formData = {
        parent_id: data.id,
        route_name: '',
        name: '',
        url: '',
        icon: '',
      };
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.isSubmit) {
            if (this.dialogTitle === 'add') {
              // 新增
              this.isSubmit = false;
              this.$http.post('/api/service/operate/permission', this.formData)
                .then(() => {
                  this.$message.success('添加成功！');
                  this.reload();
                })
                .catch((err) => {
                  this.isSubmit = true;
                  this.$message.error(err.message);
                });
            } else {
              // 修改
              this.isSubmit = false;
              this.$http.put(`/api/service/operate/permission/${this.permissionId}`, this.formData)
                .then(() => {
                  this.$message.success('修改成功！');
                  this.reload();
                })
                .catch((err) => {
                  this.isSubmit = true;
                  this.$message.error(err.message);
                });
            }
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.router {
  .tree {
    margin-top: 20px;
    .subject-edition__node {
      width: 700px;
      display: flex;
      justify-content: space-between;
      line-height: 28px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Router/index.vue